<template>
  <v-dialog
      v-model="showModel"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      style="overflow-y: auto"
  >
    <v-card flat class="fill-height of-y" style="overflow-y: auto; overflow-x: hidden">
      <v-layout column fill-height style="overflow-y: auto; overflow-x: hidden">
        <!--Card Title-->
        <v-flex shrink>
          <v-card-title class="py-0 pr-2 title-color">
            <span class="ml-2 title font-weight-light white--text">Dataset Update Script</span>
            <v-spacer></v-spacer>
            <v-tabs
                v-model="activeTab"
                color="cyan"
                dark
                slider-color="secondary"
            >
              <v-tab
                  v-for="tab in availableTabs"
                  :disabled="tab.disabled"
                  :key="tab.id"
                  ripple
              >
                {{ tab.title }}
              </v-tab>
            </v-tabs>
            <v-spacer></v-spacer>
            <v-btn flat icon color="white" class="pa-0 ma-0" @click="showModel = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
        </v-flex>
        <!--Loading-->
        <v-flex v-if="loading" class="pa-2 text-xs-center">
          <v-progress-circular
              :size="40"
              :width="5"
              color="primary"
              indeterminate
          />
        </v-flex>
        <!--Datasets Loaded-->
        <template v-else>
          <v-flex xs12 class="scrollable fill-height">
            
            <!--Select File & Dataset-->
            <template v-if="selectedTab === 'upload'">
              <div class="c-d-flex c-justify-space-around pa-3">
                <div>
                  <v-btn @click="selectExcelFile">Select File</v-btn>
                  <div v-if="excelData.length && excelColumns.length" class="caption pt-3">
                    <strong>{{ excelFilename }}</strong>
                    <br/>
                    {{ excelData.length }} Rows
                    <br/>
                    {{ excelColumns.length }} Columns
                  </div>
                </div>
                
                <div>
                  <v-autocomplete
                      outlined
                      label="Select Dataset"
                      v-model="selectedDatasetId"
                      :items="sortedDatasets"
                      item-value="id"
                      item-text="description"
                      item-disabled="disabled"
                  />
                </div>
              </div>
              <div class="c-d-flex c-justify-space-around pa-3">
                <v-btn :disabled="!excelColumns.length || !excelFilename.length || !selectedDatasetId"
                       @click="activeTab = 1">Next
                </v-btn>
              </div>
            </template>
            
            <!--Map-->
            <template v-if="selectedTab === 'map'">
              
              <!--              <div class="c-d-flex c-align-center c-justify-space-around pa-3">-->
              <!--                -->
              <!--                <span>Search Fields</span>-->
              <!--                -->
              <!--                <v-autocomplete-->
              <!--                    style="max-width: 300px"-->
              <!--                    outlined-->
              <!--                    label="Dataset Field"-->
              <!--                    v-model="mapConfig.findMap.id"-->
              <!--                    :items="datasetFields"-->
              <!--                    item-value="id"-->
              <!--                    item-text="description"-->
              <!--                    item-disabled="disabled"-->
              <!--                />-->
              <!--                -->
              <!--                <v-autocomplete-->
              <!--                    style="max-width: 300px"-->
              <!--                    outlined-->
              <!--                    label="Excel Field"-->
              <!--                    v-model="mapConfig.findMap.column"-->
              <!--                    :items="sortedColumns"-->
              <!--                />-->
              <!--              </div>-->
              
              <div class="py-2">
                
                <div style="width: 600px" class="mx-auto subheading py-2">
                  Search Field
                </div>
                
                <v-data-table
                    style="width: 600px"
                    :headers="[{text: 'Dataset Field', value: 'id', sortable: false}, {text: 'Excel Column', value: 'column', sortable: false},]"
                    :items="[mapConfig.findMap]"
                    class="elevation-1 mx-auto"
                    :rows-per-page-items="[{'text':'ALL','value': -1},5,10,25]"
                    hide-actions
                >
                  <template #no-data>
                    <v-alert :value="true" color="error" icon="warning">
                      AT LEAST ONE FIELD TO UPDATE IS REQUIRED
                    </v-alert>
                  </template>
                  <template v-slot:items="{item}">
                    <td class="text-xs-center">
                      <v-autocomplete
                          single-line
                          class="mx-auto pb-3"
                          hide-details
                          style="max-width: 300px"
                          label="Dataset Field"
                          v-model="item.id"
                          :items="datasetFields"
                          item-value="id"
                          item-text="description"
                          item-disabled="disabled"
                      />
                    </td>
                    <td class="text-xs-center">
                      <v-autocomplete
                          single-line
                          class="mx-auto pb-3"
                          hide-details
                          style="max-width: 300px"
                          label="Excel Column"
                          v-model="item.column"
                          :items="sortedColumns"
                      />
                    </td>
                  </template>
                </v-data-table>
              </div>
              
              <div class="py-2">
                
                <div style="width: 600px" class="mx-auto subheading py-2">
                  Update Fields
                </div>
                
                <v-data-table
                    style="width: 600px"
                    :headers="mapHeaders"
                    :items="mapConfig.updateMap"
                    class="elevation-1 mx-auto"
                    :rows-per-page-items="[{'text':'ALL','value': -1},5,10,25]"
                >
                  <template #no-data>
                    <v-alert :value="true" color="error" icon="warning">
                      AT LEAST ONE FIELD TO UPDATE IS REQUIRED
                    </v-alert>
                  </template>
                  <template v-slot:items="{item}">
                    <td class="text-xs-center">
                      <v-autocomplete
                          single-line
                          class="mx-auto pb-3"
                          hide-details
                          style="max-width: 300px"
                          label="Dataset Field"
                          v-model="item.id"
                          :items="usedDatasetFields"
                          item-value="id"
                          item-text="description"
                          item-disabled="disabled"
                      />
                    </td>
                    <td class="text-xs-center">
                      <v-autocomplete
                          single-line
                          class="mx-auto pb-3"
                          hide-details
                          style="max-width: 300px"
                          label="Excel Column"
                          v-model="item.column"
                          :items="usedExcelColumns"
                          item-value="id"
                          item-text="description"
                          item-disabled="disabled"
                      />
                    </td>
                    <td class="text-xs-right" style="width: 30px">
                      <v-btn small flat icon color="error"
                             @click="mapConfig.updateMap = mapConfig.updateMap.filter(v => v.id !== item.id)">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </td>
                  </template>
                  
                  <template v-slot:footer>
                    <td :colspan="mapHeaders.length">
                      <v-btn
                          small
                          flat
                          color="secondary"
                          block
                          @click="mapConfig.updateMap.push({id: null, column: null})"
                      >
                        Add field map
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <div class="text-xs-center pa-3">
                <v-btn :disabled="allowProcess !== true" @click="activeTab = 2">Next</v-btn>
                <br/>
                <span v-if="allowProcess !== true" class="caption error--text">{{ allowProcess }}</span>
              </div>
            </template>
            
            <template v-if="selectedTab === 'process'">
              <div class="c-d-flex c-justify-space-around pa-3">
                <div>
                  <v-autocomplete
                      outlined
                      label="Batch Size"
                      v-model="batchSize"
                      :items="[10,20,50,100,200]"
                  />
                </div>
                
                <div>
                  <v-btn @click="runUpdate" :loading="running" :disabled="running || ran">Run</v-btn>
                </div>
              </div>
              
              <div class="py-2">
                
                <div style="width: 600px" class="mx-auto subheading py-2">
                  Results
                </div>
                
                <v-data-table
                    style="width: 600px"
                    :headers="[{text: 'key', value: 'key', sortable: false}, {text: 'value', value: 'value', sortable: false},]"
                    :items="[
                        {key: 'progress', value: 'Not Found'},
                      {key: 'notFound', value: 'Not Found'},
                      {key: 'skipped', value: 'Skipped'},
                      {key: 'errors', value: 'Errors'},
                      {key: 'created', value: 'Created'},
                      {key: 'updated', value: 'Updated'},
                      {key: 'download', value: 'Download'},
                    ]"
                    class="elevation-1 mx-auto"
                    :rows-per-page-items="[{'text':'ALL','value': -1},5,10,25]"
                    hide-actions
                    hide-headers
                >
                  <template v-slot:items="{item}">
                    <td class="text-xs-center" v-if="item.key === 'progress'" colspan="2">
                      <div class="caption text-xs-left pt-2 pb-1">
                        Progress
                      </div>
                      <div>
                        <v-progress-linear
                            :value="(processCount / excelData.length) * 100"
                            height="5"
                            class="pa-0 ma-0"
                        ></v-progress-linear>
                      </div>
                      <div class="caption text-xs-right pb-2">
                        {{processCount}} of {{excelData.length}}
                      </div>
                    </td>
                    <template v-else-if="item.key !== 'download'">
                      <td class="">
                        {{ item.key !== 'download' ? item.value : '' }}
                      </td>
                      <td class="">
                        <template v-if="item.key !== 'download'">
                          {{ results[item.key].length }}
                        </template>
                        <template v-else>
                          <v-btn flat small block color="secondary">Download Results</v-btn>
                        </template>
                      </td>
                    </template>
                    <td class="text-xs-center" v-else colspan="2">
                      <v-btn :disabled="running || !ran" flat small block color="secondary" @click="downloadResults">
                        Download Results
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </div>
            
            </template>
          
          </v-flex>
        </template>
      </v-layout>
    </v-card>
    
    
    <!--    <input-dlg-->
    <!--        v-if="campaignUser"-->
    <!--        :show-dialog="!!campaignUser"-->
    <!--        title="Set Campaign"-->
    <!--        :cancel-button="true"-->
    <!--        :show-input-box="false"-->
    <!--        @dismiss="campaignUser = null"-->
    <!--        :body-padding="true"-->
    <!--        :width="500"-->
    <!--    >-->
    <!--      <template slot="body">-->
    <!--        -->
    <!--        <v-combobox-->
    <!--            ref="campaignCombo"-->
    <!--            :items="campaigns"-->
    <!--            hide-details-->
    <!--            :label="'New campaign for: ' + (campaignUser.name || '') + ' ' + (campaignUser.surname  || '')"-->
    <!--            v-model="editCampaignText"-->
    <!--        ></v-combobox>-->
    <!--      -->
    <!--      </template>-->
    <!--      <template #actions>-->
    <!--        <v-btn-->
    <!--            small-->
    <!--            flat-->
    <!--            color="grey"-->
    <!--            @click="campaignUser = null"-->
    <!--        >-->
    <!--          Cancel-->
    <!--        </v-btn>-->
    <!--        <v-btn-->
    <!--            small-->
    <!--            color="primary"-->
    <!--            @click="updateCampaignUser()"-->
    <!--        >-->
    <!--          Update-->
    <!--        </v-btn>-->
    <!--      </template>-->
    <!--    </input-dlg>-->
  
  
  </v-dialog>
</template>

<script>
import {codeBaseMixin} from "@/codeBaseMixin";
import InputDlg from "@/components/General/InputDlg.vue";
import {mapGetters} from "vuex";
import AiAdminSetup from "@/Ai/Admin/aiAdminSetup.vue";
import {read, utils, writeFile} from 'xlsx';


export default {
  mixins: [codeBaseMixin],
  components: {
    AiAdminSetup,
    InputDlg
    
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      loading: false,
      activeTab: 0,
      datasets: [],
      excelColumns: [],
      excelData: [],
      excelFilename: null,
      mapHeaders: [
        {text: 'Dataset Field', value: 'id', sortable: false},
        {text: 'Excel Column', value: 'column', sortable: false},
        {text: '', value: 'actions', align: 'right', sortable: false, width: 30},
      ],
      results: {
        notFound: [],
        skipped: [],
        errors: [],
        created: [],
        updated: [],
      },
      running: false,
      ran: false,
      batchSize: 10,
      processCount: 0
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(shown) {
        this.startup();
      }
    },
    campaignUser(val) {
      if (val) {
        this.editCampaignText = val.campaign || ''
        setTimeout(() => {
          this.$refs.campaignCombo.focus();
        }, 500)
      }
    }
  },
  methods: {
    
    selectExcelFile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx, .xls'; // Only accept Excel files
      
      // Add event listener for when a file is selected
      input.addEventListener('change', async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        
        try {
          const data = await this.readExcelFile(file);
          this.excelColumns = Object.keys(data[0]);
          this.excelData = data
          this.excelFilename = file.name;
        } catch (error) {
          console.error('Error reading Excel file:', error);
          this.$snack.error(e.message || 'Something Went Wrong')
        } finally {
          // document.removeChild(input);
        }
      });
      
      // Trigger the file selection dialog
      input.click();
    },
    
    async readExcelFile(file) {
      // We'll use the SheetJS library (xlsx) for parsing Excel files
      // Make sure to add it to your project: npm install xlsx
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = async (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = read(data, {type: 'array'});
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = utils.sheet_to_json(worksheet, {
                  raw: false,
                  cellDates: true,
                }
            );
            resolve(jsonData);
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
      });
    },
    
    
    async startup() {
      try {
        this.loading = true;
        const {datasets} = await this.$newReq('get', 'clientScripts/dataset/startup')
        this.datasets = datasets;
      } catch (e) {
        console.log(e)
        this.$snack.networkError();
      } finally {
        this.loading = false
      }
    },
    
    async runUpdate() {
      try {
        this.running = true;
        this.ran = true
        this.processCount = 0;
        this.results = {
          notFound: [],
          skipped: [],
          errors: [],
          created: [],
          updated: [],
        }
        
        let toRun = [...this.excelData]
        
        while (toRun.length > 0) {
          const batch = toRun.splice(0, Math.min(this.batchSize, toRun.length))
          
          const {notFound, skipped, errors, created, updated} = await this.$newReq('post', 'clientScripts/dataset/run', {
            config: this.mapConfig,
            data: batch,
          })
          
          this.processCount += batch.length
          this.results.notFound = this.results.notFound.concat(notFound);
          this.results.skipped = this.results.skipped.concat(skipped);
          this.results.errors = this.results.errors.concat(errors);
          this.results.created = this.results.created.concat(created);
          this.results.updated = this.results.updated.concat(updated);
        }
        
        // const batchesToRun = this.excelData.reduce((acc, item, index) => {
        //   if (!acc.length || index % this.batchSize === 0) acc.push([])
        //   acc[acc.length - 1].push(item)
        //   return acc
        // }, [])
        //
        // for (const batch of batchesToRun) {
        //   const {notFound, skipped, errors, created, updated} = await this.$newReq('post', 'clientScripts/dataset/run', {
        //     config: this.mapConfig,
        //     data: batch,
        //   })
        //
        // }
      } catch (e) {
        console.log(e)
        this.$snack.networkError();
      } finally {
        this.running = false
      }
    },
    
    downloadResults() {
      const workbook = utils.book_new();
      
      // notFound
      // skipped
      // created
      // updated
      
      
      const sheetsData = {
        'Created Values': {
          headers: ['Search Key', 'Field', 'Value'],
          data: this.results.created
        },
        'Updated Values': {
          headers: ['Search Key', 'Field', 'Value'],
          data: this.results.updated
        },
        'Skipped Values': {
          headers: ['Search Key', 'Field', 'Reason'],
          data: this.results.skipped
        },
        'Not Matched': {
          headers: ['Search Key'],
          data: this.results.notFound.map(v => [v])
        },
        'Errors': {
          headers: ['Search Key', 'Field', 'Error'],
          data: this.results.errors
        }
      };
      
      
      // Process each sheet
      for (const [sheetName, sheetConfig] of Object.entries(sheetsData)) {
        const {headers, data, dateColumns = []} = sheetConfig;
        
        // Combine headers and data
        const worksheetData = [headers, ...data];
        
        // Create worksheet
        const worksheet = utils.aoa_to_sheet(worksheetData);
        
        // Format date columns
        if (dateColumns.length > 0) {
          // Find column indexes
          const dateColumnIndexes = dateColumns.map(col => headers.indexOf(col))
              .filter(index => index !== -1);
          
          // Apply date formatting
          for (let rowIndex = 1; rowIndex < worksheetData.length; rowIndex++) {
            for (const colIndex of dateColumnIndexes) {
              const cellRef = utils.encode_cell({r: rowIndex, c: colIndex});
              if (worksheet[cellRef]) {
                worksheet[cellRef].z = 'yyyy-mm-dd';
              }
            }
          }
        }
        
        // Add worksheet to workbook
        utils.book_append_sheet(workbook, worksheet, sheetName);
      }
      
      // Generate and download
      writeFile(workbook, 'Update Results.xlsx');
    }
    
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    
    datasetFields() {
      const dataset = this.datasets.find(d => d.id === this.selectedDatasetId)
      const fields = (dataset?.fields || []).toSorted((a, b) => {
        if (a.visibile !== b.visibile) return a.visibile ? 1 : -1;
        return a.description.localeCompare(b.description);
      })
      
      return fields;
    },
    
    usedDatasetFields() {
      const dataset = this.datasets.find(d => d.id === this.selectedDatasetId)
      const fields = (dataset?.fields || []).toSorted((a, b) => {
        if (a.visibile !== b.visibile) return a.visibile ? 1 : -1;
        return a.description.localeCompare(b.description);
      })
      
      const usedFields = this.mapConfig.updateMap.map(v => v.id)
      
      return fields.map(v => ({
        id: v.id,
        description: v.description,
        disabled: usedFields.includes(v.id)
      }));
    },
    
    usedExcelColumns() {
      
      const usedColumns = this.mapConfig.updateMap.map(v => v.column)
      
      return this.sortedColumns.map(v => ({
        id: v,
        description: v,
        disabled: usedColumns.includes(v)
      }));
    },
    
    sortedColumns() {
      return this.excelColumns.toSorted()
    },
    
    mapConfig() {
      return this.$store.state.datasetUpdaterMap;
    },
    
    selectedDatasetId: {
      get() {
        return this.$store.state.datasetUpdaterMap.datasetId;
      },
      set(value) {
        this.$store.state.datasetUpdaterMap.datasetId = value;
        this.$store.state.datasetUpdaterMap.findMap.id = null;
        this.$store.state.datasetUpdaterMap.findMap.column = null;
        this.$store.state.datasetUpdaterMap.updateMap = [];
      }
    },
    
    sortedDatasets() {
      return this.datasets.toSorted((a, b) => {
        if (a.visibile !== b.visibile) return a.visibile ? 1 : -1;
        return a.description.localeCompare(b.description);
      })
    },
    
    availableTabs() {
      return [
        {title: 'Upload', id: 'upload'},
        {
          title: 'Config',
          id: 'map',
          disabled: !this.excelColumns.length || !this.excelFilename.length || !this.selectedDatasetId
        },
        {
          title: 'Process',
          id: 'process',
          disabled: (!this.excelColumns.length || !this.excelFilename.length || !this.selectedDatasetId) || this.allowProcess !== true
        },
      ]
    },
    
    allowProcess() {
      if (!this.mapConfig.findMap.id) return 'Search Field: dataset field is required'
      if (!this.mapConfig.findMap.column) return 'Search Field: excel column is required'
      if (!this.mapConfig.updateMap.length) return 'Update Fields: at least one field is required'
      if (this.mapConfig.updateMap.filter(v => !v.id).length) return 'Update Fields: missing dataset field config'
      if (this.mapConfig.updateMap.filter(v => !v.column).length) return 'Update Fields: missing excel column config'
      const notFoundColumns = this.mapConfig.updateMap.map(v => v.column)
          .filter(v => !this.excelColumns.includes(v))
          
      if (notFoundColumns.length) return `Invalid Excel Column: "${notFoundColumns[0]}" not found in the excel file`
      return true;
    },
    
    selectedTab() {
      return this.availableTabs[this.activeTab]?.id
    },
    
    showModel: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
    
  }
}
</script>

<style scoped>


</style>
